module.exports = __webpack_public_path__ + "img/证书.c2f92459.png";